export const SEARCH_EVENT_LOAD = 'SEARCH_EVENT_LOAD';
export const SEARCH_EVENT_LOAD_SUCCESS = 'SEARCH_EVENT_LOAD_SUCCESS';
export const SEARCH_EVENT_LOAD_FAIL = 'SEARCH_EVENT_LOAD_FAIL';
export const FILTERED_PRODUCT = 'FILTERED_PRODUCT';
export const SEARCH_EVENT_BY_ID_LOAD = 'SEARCH_EVENT_BY_ID_LOAD';
export const SEARCH_EVENT_BY_ID_LOAD_SUCCESS = 'SEARCH_EVENT_BY_ID_LOAD_SUCCESS';
export const SEARCH_EVENT_BY_ID_LOAD_FAIL = 'SEARCH_EVENT_BY_ID_LOAD_FAIL';
export const SEARCH_DATA = 'SEARCH_DATA';
export const EVENT_DATE_RANGE = 'EVENT_DATE_RANGE';
export const CLEAN_STATE_WARNING = 'CLEAN_STATE_WARNING';
export const ADD_ALL_EVENT_SEARCH_BY_USER_DETAILS = 'ADD_ALL_EVENT_SEARCH_BY_USER_DETAILS';
export const CLEAN_SEARCH_USER_DETAILS = 'CLEAN_SEARCH_USER_DETAILS';

export function isSearchEventLoaded(globalState) {
  return globalState.searchResult && globalState.searchResult.loaded;
}

export function eventSearchByUserDetails(eventSerachData) {
  const eventSerachDataPayload = eventSerachData;
  eventSerachDataPayload.channel = 'WEB';
  eventSerachDataPayload.brand = 'LP';
  eventSerachDataPayload.pageNum = eventSerachData.pageNum.toString();
  return {
    types: [SEARCH_EVENT_LOAD, SEARCH_EVENT_LOAD_SUCCESS, SEARCH_EVENT_LOAD_FAIL],
    promise: client => client.post('/api/searchResult', {
      data: (eventSerachDataPayload),
    }), // params not used, just shown as demonstration
  };
}

export function searchEventByEventId(eventSerachDataById) {
  const eventSerachDataByIdPayload = eventSerachDataById;
  eventSerachDataByIdPayload.brand = 'LP';
  eventSerachDataByIdPayload.channel = 'WEB';
 return (dispatch) => {
    // Return the dispatch promise here
    return dispatch({
      types: [SEARCH_EVENT_BY_ID_LOAD, SEARCH_EVENT_BY_ID_LOAD_SUCCESS, SEARCH_EVENT_BY_ID_LOAD_FAIL],
      promise: client => client.post('/api/searchResultById', {
        data: eventSerachDataByIdPayload,
      })
    }).then(response => {
      dispatch({type: CLEAN_SEARCH_USER_DETAILS})
      return response; // Make sure to return the response
    });
  };
}

export function addAllEventSearchByUserDetails(eventSerachData) {
  return {
    type: ADD_ALL_EVENT_SEARCH_BY_USER_DETAILS,
    payload: eventSerachData,
  };
}

export function cleanSearchByUserDetails() {
  return {
    type: CLEAN_SEARCH_USER_DETAILS,
  };
}

